export const minmax = (arr) => [Math.min(...arr), Math.max(...arr)]
export const sum = (arr) => arr.reduce((a, b) => a + b, 0)
export const average = (arr) => sum(arr) / arr.length
export const weightedAverage = (arr, count) => arr.reduce((acc, i, x) => acc + (i * (x + 1)), 0) / count

export function partition(arr, test) {
    return arr.reduce((acc, e) => {
        acc[test(e) ? 0 : 1].push(e)
        return acc
    }, [[], []])
}

export function sortByKey(key) {
    return (a, b) => {
        if (a[key] < b[key]) {
            return -1
        }

        if (a[key] > b[key]) {
            return 1
        }

        return 0
    }
}

export function fillRange(min, max, step) {
    return Array(Math.ceil((max - min) / step) + 1).fill(min).map((x, y) => x + y * step)
}

// https://stackoverflow.com/a/326746/214270
export function niceScale(min, max, maxTicks = 10) {
    const rough = (max - min) / (maxTicks - 1)
    const pow = 10 ** Math.ceil(Math.log10(rough) - 1)
    const increment = Math.ceil(rough / pow) * pow
    const lower = Math.floor(min / increment) * increment
    const upper = Math.ceil(max / increment) * increment
    return [lower, upper, increment]
}
